(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('NumReferenceContratDetailController', NumReferenceContratDetailController);

    NumReferenceContratDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'NumReferenceContrat', 'Agence'];

    function NumReferenceContratDetailController($scope, $rootScope, $stateParams, entity, NumReferenceContrat, Agence) {
        var vm = this;
        vm.numReferenceContrat = entity;
        vm.load = function (id) {
            NumReferenceContrat.get({id: id}, function(result) {
                vm.numReferenceContrat = result;
            });
        };
        var unsubscribe = $rootScope.$on('wamasysApp:numReferenceContratUpdate', function(event, result) {
            vm.numReferenceContrat = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
